<template>
  <div class="import-container" style="text-align: center;">
    <h5>证明信息上传</h5>
    <el-select v-model="selectedSemesterUuid" placeholder="请选择学期" style="margin-bottom: 20px;">
      <el-option
        v-for="(semester, index) in semesters"
        :key="semester.uuid"
        :label="semester.name"
        :value="semester.uuid">
        <span>{{ semester.name }}</span>
        <template v-if="index === 0">
          <el-tag type="primary" style="margin-left: 10px;">当前学期</el-tag>
        </template>
      </el-option>
    </el-select>
    <el-upload
      class="upload-excel"
      ref="uploadRef"
      action=""
      :http-request="handleUpload"
      :before-upload="beforeUpload"
      accept=".xlsx, .xls"
      auto-upload="false"
    >
      <template #trigger>
        <el-button type="primary">选择Excel文件</el-button>
      </template>
    </el-upload>
    <el-button
      style="margin-left: 10px;"
      type="success"
      @click="submitFile"
      :loading="loading"
    >上传到服务器</el-button>

    <!-- 错误信息对话框 -->
    <el-dialog
      v-model="errorDialogVisible"
      title="错误信息"
      width="30%">
      <span>{{ errorMessage }}</span>
      <template #footer>
        <el-button @click="errorDialogVisible = false">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessage } from 'element-plus';
import axios from 'axios';

export default {
  name: 'ImportPage',
  data() {
    return {
      file: null,
      loading: false,
      semesters: [],
      selectedSemesterUuid: '',
      errorDialogVisible: false,
      errorMessage: '',
    };
  },
  mounted() {
    this.fetchSemesters();
  },
  methods: {
    async fetchSemesters() {
      try {
        const response = await axios.get('/api/semesters');
        this.semesters = response.data.semesters;
      } catch (error) {
        console.error('获取学期数据失败:', error);
        ElMessage.error('获取学期数据失败');
      }
    },
    beforeUpload(file) {
      this.file = file;
      return false;
    },
    handleUpload() {
      // 这个方法可以留空，因为我们会手动上传文件
    },
    async submitFile() {
      if (!this.file) {
        ElMessage.error('请先选择一个文件');
        return;
      }
      if (!this.selectedSemesterUuid) {
        ElMessage.error('请选择一个学期');
        return;
      }
      this.loading = true;
      const formData = new FormData();
      formData.append('file', this.file);
      formData.append('semesterUuid', this.selectedSemesterUuid);

      try {
        const response = await axios.post('/api/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        this.loading = false;
        ElMessage.success(response.data.message || '文件上传成功');
        this.file = null;
        this.selectedSemesterUuid = '';
        this.$refs.uploadRef.clearFiles();
      } catch (error) {
        this.loading = false;
        this.errorMessage = error.response?.data?.error || '文件上传失败';
        this.errorDialogVisible = true; // 显示错误对话框
      }
    },
  },
};
</script>
